import { message } from "antd";
import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createInsuranceDetailsReportSlice = (set, get) => ({
    insuranceDetails: {
        loading: false,
        comments: [],
        infos: {}
    },
    getInsuranceDetailsInfo: async (insuranceRequestId) => {
        if (insuranceRequestId) {
            const token = usePersistedStore.getState().business.currentBusiness.token;
            set(state => ({ insuranceDetails: { ...state.insuranceDetails, loading: true } }));
            try {
                const resp = await axiosInstance({
                    method: "get",
                    baseURL: config.apiUrls(),
                    url: `/v1/business/insurance/${insuranceRequestId}/info`,
                    headers: { token }
                });
                set(state => ({ insuranceDetails: { ...state.insuranceDetails, loading: false, infos: resp.data } }));
            } catch (error) {
                set(state => ({ insuranceDetails: { ...state.insuranceDetails, loading: false, infos: [] } }));
            }
        } else {
            message?.error("شناسه درخواست معتبر نیست")
        }
    }
});
